'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Drop target


// Decorators


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _dontUpdateForKeys = require('../../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _elementCaptionUtil = require('../../components/caption/elementCaptionUtil');

var _fieldValidationService = require('../../../common/validation/fieldValidationService');

var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);

var _ColumnOnDropDropTarget = require('../column/ColumnOnDropDropTarget');

var _ColumnOnDropDropTarget2 = _interopRequireDefault(_ColumnOnDropDropTarget);

var _columnOnDropConnectDropTarget = require('../column/columnOnDropConnectDropTarget');

var _columnOnDropConnectDropTarget2 = _interopRequireDefault(_columnOnDropConnectDropTarget);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

var _captionContainerDecorator = require('../../components/caption/captionContainerDecorator');

var _captionContainerDecorator2 = _interopRequireDefault(_captionContainerDecorator);

var _linkActions = require('./linkActions');

var _elementShortcutActions = require('../elementShortcutActions');

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchSetLinkElementUrl: function dispatchSetLinkElementUrl(id, url) {
            return dispatch((0, _linkActions.setLinkElementUrl)({ id: id, url: url }));
        },
        dispatchMoveElementToTrash: function dispatchMoveElementToTrash(_ref) {
            var isEditable = _ref.isEditable,
                currentBoardId = _ref.currentBoardId;
            return dispatch((0, _elementShortcutActions.moveElementToTrash)({ isEditable: isEditable, currentBoardId: currentBoardId }));
        }
    };
};

var LinkContainer = (_dec = (0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector, mapDispatchToProps), _dec2 = (0, _dontUpdateForKeys2.default)(['dragModifierKeys', 'canDrop']), _dec(_class = (0, _elementLineEdgeDropTarget2.default)(_class = (0, _ColumnOnDropDropTarget2.default)(_class = _dec2(_class = (0, _captionContainerDecorator2.default)(_class = function (_React$Component) {
    _inherits(LinkContainer, _React$Component);

    function LinkContainer(props) {
        _classCallCheck(this, LinkContainer);

        var _this = _possibleConstructorReturn(this, (LinkContainer.__proto__ || Object.getPrototypeOf(LinkContainer)).call(this, props));

        _this.handleKey = function (event) {
            if (!_this.props.isSelected) return;
            if (event.target !== _this.container) return;
            if (!_this.props.element.getIn(['content', 'link', 'url'])) return;
            _this.props.captionKeyHandler(event, _this.props);
        };

        _this.setTempContent = _this.setTempContent.bind(_this);
        _this.setLinkUrl = _this.setLinkUrl.bind(_this);
        _this.moveElementToTrash = _this.moveElementToTrash.bind(_this);
        return _this;
    }

    _createClass(LinkContainer, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            // focus on mount
            var url = this.props.element.getIn(['content', 'link', 'url']);
            var oldUrl = oldProps.element.getIn(['content', 'link', 'url']);

            var showCaption = (0, _elementCaptionUtil.getShowCaption)(this.props.element);
            var oldShowCaption = (0, _elementCaptionUtil.getShowCaption)(oldProps.element);

            if (url && !oldUrl) {
                this.container.focus();
            }

            if (!showCaption && oldShowCaption) {
                this.container.focus();
            }
        }
    }, {
        key: 'setTempContent',
        value: function setTempContent(tempContent) {
            var _props = this.props,
                dispatchUpdateElement = _props.dispatchUpdateElement,
                element = _props.element;


            dispatchUpdateElement({
                id: element.get('id'),
                changes: { temp: tempContent },
                sync: false,
                transactionId: null
            });
        }
    }, {
        key: 'setLinkUrl',
        value: function setLinkUrl(url) {
            var _props2 = this.props,
                dispatchSetLinkElementUrl = _props2.dispatchSetLinkElementUrl,
                element = _props2.element;


            var validationError = (0, _fieldValidationService2.default)(url, { type: 'url', allowIPAddress: true, required: true });

            if (validationError) return validationError;
            dispatchSetLinkElementUrl(element.get('id'), url);
        }
    }, {
        key: 'moveElementToTrash',
        value: function moveElementToTrash() {
            this.props.dispatchMoveElementToTrash(this.props);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                connectLineEdgeDropTarget = _props3.connectLineEdgeDropTarget,
                inList = _props3.inList;


            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;

            return (0, _columnOnDropConnectDropTarget2.default)(this.props, lineEdgeConnector(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'LinkContainer',
                        ref: function ref(c) {
                            _this2.container = c;
                        },
                        onKeyDown: this.handleKey,
                        tabIndex: '-1' },
                    _react2.default.createElement(_Link2.default, _extends({}, this.props, { setLinkUrl: this.setLinkUrl, setTempContent: this.setTempContent,
                        moveElementToTrash: this.moveElementToTrash }))
                )
            )));
        }
    }]);

    return LinkContainer;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = LinkContainer;


LinkContainer.propTypes = {
    element: _propTypes2.default.object.isRequired,
    isEditing: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    startEditing: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    dispatchShowCaption: _propTypes2.default.func,
    dispatchSetLinkElementUrl: _propTypes2.default.func,
    dispatchUpdateElement: _propTypes2.default.func,
    dispatchMoveElementToTrash: _propTypes2.default.func,
    connectDropTarget: _propTypes2.default.func,
    connectLineEdgeDropTarget: _propTypes2.default.func,
    inList: _propTypes2.default.string,
    captionKeyHandler: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/LinkContainer.js
// module id = 1998
// module chunks = 0